import { render, staticRenderFns } from "./CadCobranca.vue?vue&type=template&id=01870346&"
import script from "./CadCobranca.vue?vue&type=script&lang=js&"
export * from "./CadCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports